import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from "@material-ui/core/Typography";
import moment from "moment";
 
class TransactionHistory extends Component {
    state = {
        captchaTextVal: false
    }
 
   render() {
    const { transactions, transactionLoading  , isZero} = this.props;
       return (<div className='account-history-list-wrapper'>
          {
            transactionLoading ?
            <Typography align="center" variant='subtitle1' ><CircularProgress size={30} thickness={4} style={{color: '#F29900', marginTop: '20px'}} /></Typography>
            :
                // <div>
                //     <div className='listTransactions'>
                //     <div class="leftBox">
                //         <b>{transaction['mode_of_payment'] === "bank" ? "Bank Account" : transaction['mode_of_payment'] === "paytm" ? "Paytm Wallet" : transaction['mode_of_payment']}</b>
                //     </div>
                //     <div class="middleBox">
                //         {transaction['redeem_amount']}
                //     </div>
                //     <div class="middleBox1">
                //         {moment(transaction['date_time'].split(' ')[0], 'DD/MM/YYYY').format("Do MMMM YYYY")}
                //     </div>
                //     <div class="rightBox">
                //         {moment(transaction['date_time'].split(' ')[1], 'HH:mm').format('h:mm A')}
                //     </div>
                //         {/* <div className='leftBox'>
                //             <b>{transaction['mode_of_payment']}</b>
                //             <br></br>
                //             {transaction['redeem_amount']}
                //         </div>
                //         <div className='middleBox'></div>
                //         <div className='rightBox'>
                //             {transaction['date_time'].split(' ')[0]}
                //             <br></br>
                //             {transaction['date_time'].split(' ')[1]}
                //         </div>  */}
                //     </div>
                //     <br></br>
                // </div>
                <ul className='bankListWrap'>
                {transactions.length >0 && transactions.map((transaction, i) => (
                    <li className='bankItem'>
                        <div className='bankLeftDetails'>
                            <p className='bankName'>{transaction['mode_of_payment'] === "bank" ? "Bank Account" : transaction['mode_of_payment'] === "paytm" ? "Paytm Wallet" : transaction['mode_of_payment']}</p>
                            <p className='cardtype'>{transaction['redeem_amount']}</p>
                        </div>
                        <div className='bankRightDetails'>
                            { isZero === "Yes" && <p className='bankName' style={{ marginBottom : "5px"}}>{transaction["coupon_code"]}</p>}
                            <p className='transitionDate'>{moment(transaction['date_time'].split(' ')[0], 'DD/MM/YYYY').format("Do MMMM YYYY")}&nbsp;{moment(transaction['date_time'].split(' ')[1], 'HH:mm').format('h:mm A')}</p>
                        </div>
                    </li>
                ))}
                </ul>
            }
       </div>);
   };
}
 
export default TransactionHistory;